const messages = {
  title: "Produktinformationen UND Freigaben",
  description:
    "Benvenuto nell'area brochure e listini dedicata ai prodotti Bridgestone e Firestone. Qui trovi brochure e listini aggiornati per tutti i segmenti, oltre ai file Pricat per i tuoi sistemi gestionali.",
  productInfo: {
    categories: {
      info: "Listini prezzi",
      priceList: "Listini prezzi",
      contact: "Contatto",
    },
    page: {
      description:
        "Benvenuto nell’area informativa dedicata ai prodotti Bridgestone & Firestone.<br/>Qui trovi brochure e listini prezzi aggiornati, oltre a link utili e moduli.",
    },
    index: {
      title: "Informazioni sui prodotti",
      description:
        "Benvenuto nell’area informativa dedicata ai prodotti Bridgestone e Firestone.<br/>Qui trovi brochure aggiornate e materiale aggiuntivo.",
      categories: {
        productBrochures: {
          title: "Brochure prodotti",
          description:
            "Brochure prodotti Bridgestone e Firestone aggiornate da scaricare",
        },
        bDrive: {
          title: "Immagini dei pneumatici &<br/>loghi",
          description:
            "Loghi, immagini dei prodotti e materiali marketing aggiornati",
          button: "VAI A B-DRIVE",
        },
        calculator: {
          title:
            "Calcolatore di risparmio<br/><span class='text-danger'>carburante</span>",
          description:
            "Pneumatici con resistenza al rotolamento ottimizzata – calcola facilmente il potenziale di risparmio!",
        },
        carApprovals: {
          title: "Omologazioni auto Bridgestone",
          description:
            "Trova gli pneumatici Bridgestone omologati e adatti alla tua vettura",
        },
        carApprovalsFS: {
          title: "Omologazioni auto Firestone",
          description:
            "Trova gli pneumatici Firestone omologati e adatti alla tua vettura",
        },
        motApprovals: {
          title: "Omologazioni moto",
          description:
            "Trova gli pneumatici moto Bridgestone omologati e adatti",
        },
        dataGenereate: {
          title: "Generatore di schede tecniche",
          description:
            "Inserisci l’IPC e genera la tua scheda tecnica personalizzata",
        },
      },
    },
  },
  priceDescription: "Scarica i listini prezzi aggiornati per il tuo utilizzo.",
  pricatDescription:
    "Qui puoi ottenere i file Pricat per il tuo sistema gestionale.",
  pricat: {
    title: "Pricat",
    description:
      "Scarica qui file CSV e TEXT per i tuoi sistemi gestionali, informatici e altro.",
  },
  pkw: {
    title: "Listini prezzi dei pneumatici per auto, 4x4 e furgoni",
    description:
      "Scaricate qui i listini prezzi aggiornati dei nostri pneumatici Bridgestone e Firestone",
  },
  trucksAndBuses: {
    title: "Listini prezzi per autocarri e autobus",
    description:
      "Scaricate qui i listini prezzi aggiornati dei nostri pneumatici Bridgestone e Firestone: <ul> <li>Camion e autobus</li> </ul>",
  },
  motorcycles: {
    title: "Listini prezzi dei pneumatici per moto",
    description:
      "Scaricate qui i listini prezzi attuali dei nostri pneumatici Bridgestone: <ul> <li>Moto</li> </ul>",
  },
  agriculture: {
    title: "Listini prezzi degli pneumatici agricoli",
    description:
      "Scaricate qui i listini prezzi attuali dei nostri pneumatici Bridgestone e Firestone: <ul> <li>Agricoltura</li> </ul>",
  },
  constructionMachineryOtr: {
    title: "Listini prezzi per macchine da costruzione/pneumatici OTR",
    description:
      "Scaricate qui i listini prezzi attuali dei nostri pneumatici Bridgestone e Firestone: <ul><li>Macchine edili/OTR</li></ul>",
  },
  main: {
    title: "Listini prezzi",
    description:
      "Scaricate qui i listini prezzi aggiornati dei nostri pneumatici Bridgestone e Firestone: <ul><li>Pneumatici per auto, 4x4 e furgoni</li><li>moto</li><li>Camion e autobus</li> <li>Pneumatici agricoli</li><li>Macchine edili / OTR</li></ul>",
  },
  index: {
    description:
      "Benvenuti nell'area informazioni sui prodotti Bridgestone e Firestone. Qui troverete opuscoli aggiornati, listini prezzi e file Pricat.",
  },
};
export default {
  messages,
};
